import { IEcpStore } from '../../rest/ecp-locator';
import { EcpMapUserLocation } from '../../models';

export const getLatLng = (obj: EcpMapUserLocation | IEcpStore) => {
  const lat = Number(obj.latitude);
  const lng = Number(obj.longitude);
  return { lat, lng };
};
